export enum DNS_KEYS {
  disableSwitchEventNotification = "disableSwitchEventNotification",
  disableSwitchFloorNotification = "disableSwitchFloorNotification",
  disableSwitchScreenFocusModeNotification = "disableSwitchScreenFocusModeNotification",
  hasClosedFirstTimeEventDirectoryNudge = "hasClosedFirstTimeEventDirectoryNudge",
}
